import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

export const NotFound = (props: any) => {
  const navigate = useNavigate();

  const goDashboard = () => {
    navigate("/");
  };

  return (
    <div className="exception-body notfound">
      <div className="exception-panel">
        <h1>404</h1>
        <h3>not found</h3>
        <p>The page that you are looking for does not exist</p>
      </div>
      <div className="exception-footer">
        <img
          src={`assets/layout/images/logo-${props.colorScheme === "light" ? "dark" : "light"}.png`}
          className="exception-logo"
          alt="expection-logo"
        />
      </div>
    </div>
  );
};
